import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '@/common/jwt.service'
import { API_URL } from '@/common/config'

const ApiService = {
	init () {
		Vue.use(VueAxios, axios)
		Vue.axios.defaults.baseURL = API_URL
		Vue.axios.defaults.withCredentials = true
		//Vue.axios.defaults.headers = { 'Access-Control-Expose-Headers': 'Access-Control-Allow-Credentials'}
	},

	setHeader () {
		Vue.axios.defaults.headers.common['Authorization'] = `Token ${JwtService.getToken()}`
	},

	query (resource, params) {
		return Vue.axios
			.get(resource, params)
			// .catch((error) => {
			//   throw new Error(`[Manager] ApiService ${error}`)
			// })
	},

	getBy (resource, slug = '') {
		return Vue.axios
			.get(`${resource}/${slug}`)
			// .catch((error) => {
			//   throw new Error(`[Manager] ApiService ${error}`)
			// })
	},

	get (resource) {
		return Vue.axios
			.get(`${resource}`)
			// .catch((error) => {
			//   throw new Error(`[Manager] ApiService ${error}`)
			// })
	},

	post (resource, params) {
		return Vue.axios
			.post(`${resource}`, params)
	},

	update (resource, slug, params) {
		return Vue.axios
			.post(`${resource}/${slug}`, params)
	},

	put (resource, params) {
		return Vue.axios
			.put(`${resource}`, params)
	},

	delete (resource) {
		return Vue.axios
			.delete(resource)
			// .catch((error) => {
			//   throw new Error(`[Manager] ApiService ${error}`)
			// })
	},

	getFile (resource) {
		return Vue.axios
			.get(`${resource}`, {responseType: 'blob' })
	},
}

export default ApiService


// WEBPACK FOOTER //
// ./src/common/api.service.js